import { useState, useEffect } from "react";
import ModalWrapper from 'components/ModalWrapper'
import { useTranslation } from "react-i18next";
import { BiTrash } from 'react-icons/bi'
import PropTypes from 'prop-types';

const OnDeleteConfirm = ({ onConfirm, disabled, title, subtitle,actionTitle }) => {

    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
    }, [isOpen])


    const options = {
        title: t('modal.delete.title') ,
        subtitle: t('modal.delete.subtitle'),
        negativeAction: t('modal.delete.negative_action'),
        positiveAction: t('modal.delete.positive_action'),
    }


    return (
        <>
            <button disabled={!!disabled}
                className={`capitalize font-bold text-lg  focus:outline-none focus:ring-2 focus:ring-offset-2  transition duration-150 ease-in-out 
                rounded p-2  ${disabled && 'bg-gray-200 text-gray-400'}`}
                onClick={() => setIsOpen(true)}>
               {actionTitle} <BiTrash />
            </button>
            <ModalWrapper
                open={isOpen}
                setOpen={setIsOpen}
            >
                <div className="flex h-full flex-col  text-center justify-between items-center ">
                    <div className="bg-red-100 p-4 rounded-full">
                        <svg width="32" height="32" className=" text-red-500" fill="currentColor" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                            <path d="M704 1376v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm-544-992h448l-48-117q-7-9-17-11h-317q-10 2-17 11zm928 32v64q0 14-9 23t-23 9h-96v948q0 83-47 143.5t-113 60.5h-832q-66 0-113-58.5t-47-141.5v-952h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h309l70-167q15-37 54-63t79-26h320q40 0 79 26t54 63l70 167h309q14 0 23 9t9 23z">
                            </path>
                        </svg>
                    </div>

                    <p className="text-gray-800  text-xl font-bold mt-4">
                        {options.title}
                    </p>
                    <p className="text-gray-600 text-sm py-2 px-6">
                        {options.subtitle}
                    </p>
                    <div className="flex items-center justify-center w-full mt-8">

             

                        <button className="capitalize shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-700 transition duration-150 ease-in-out hover:bg-red-600 bg-red-500 rounded text-white px-8 py-2 text-sm "
                            onClick={() => {
                                setIsOpen(false)
                                onConfirm();
                            }}
                        >   {t('actions.delete')}

                        </button>

                        <button className="capitalize shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  focus:ring-gray-400  bg-gray-100 transition duration-150 text-gray-600 ease-in-out hover:border-gray-400 hover:bg-gray-300 border rounded px-8 py-2 text-sm ml-3"
                            onClick={() => setIsOpen(false)}
                        >   {t('actions.cancel')}
                        </button>

                    </div>

                </div>
            </ModalWrapper>

        </>

    );

}

OnDeleteConfirm.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  actionTitle: PropTypes.node,
};

export default OnDeleteConfirm;


